<template>
  <AbsPopup id="ReportMenu" title="비공개 사유 선택" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <li v-for="(item, idx) in list" :key="idx">
          <label><input type="radio" name="type" :value="idx" @change="radioChange"/>
          {{ item }}</label>
        </li>
        <li>
          <label><input type="radio" name="type" :value="list.length" @change="radioChange"/>
          기타 ({{ commentEx.length }}/500)</label>
          <UInput v-if="parseInt(commentIdx) === list.length" type="textarea" :limitHeight="100" :auto="true" placeholder="사유와 하실 말씀을 적어 주세요" v-model="commentEx" :limit="500" @focus="$store.commit('popup', false)" @focusout="$store.commit('popup', true)"/>
        </li>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.option.param) {
      console.log(this.option.param)
      this.$emit('loading', false)
    }
  },
  data () {
    return {
      commentEx: '',
      commentIdx: -1
    }
  },
  name: 'ReportMenu',
  computed: {
    list () {
      switch (this.option.param.type) {
        case 1 :
          return [
            '부적합한 홍보 제목',
            '음란성 또는 청소년에게 부적합한 제목',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
        case 2 :
          return [
            '부적절한 프로필 사진',
            '부적절한 필명',
            '부적절한 홍보 소개 글',
            '음란성 또는 청소년에게 부적합한 소개 글',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
        case 3 :
          return [
            '부적절한 작가(책) 소개',
            '음란성 또는 청소년에게 부적합한 작가(책) 소개',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
        default :
          return [
            '부적합한 홍보 게시글',
            '음란성 또는 청소년에게 부적합한 내용',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
      }
    }
  },
  methods: {
    radioChange (e) {
      console.log(e.target.value)
      this.commentIdx = e.target.value
      switch (e.target.value) {
        case this.list.length :
          break
        default :
          this.commentEx = ''
          break
      }
    },
    submit () {
      var idar = []
      this.option.param.report.forEach(item => {
        idar.push(item._id)
      })
      console.log(idar)
      var cm = ''
      if (this.commentIdx === this.list.length) {
        cm = this.commentEx
      } else {
        cm = this.list[this.commentIdx]
      }
      console.log(this.option.param)
      var user
      if (this.option.param.user) {
        user = this.option.param.user._id
      } else {
        user = this.option.param.reportUser._id
      }
      console.log('report', this.option.param._id)
      this.$http.post('/api/admin/cs/state', {re: Boolean(this.option.param.user), type: this.option.param.type, report: this.option.param._id, ids: idar, state: (this.option.param.type !== 5) ? 'visible' : 'delete', message: cm, user: user}).then((row) => {
        console.log(row)
        if (row.success) {
          this.$emit('submit', this.option.param)
        } else {
        }
      })
      // this.$emit('submit', {})
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#ReportMenu {
  padding: 10px 0;
  width: 400px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
}
.popup-body > li {
  display: flex;
  flex-direction: column;
  list-style: none;
  min-height: 25px;
}
.popup-body > div > li:last-child {
  margin-left: auto;
  color: var(--text-base);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/ReportMenu.vue